export function getEventTargetAttr(event, attr) {
  return (event.target || {})[attr] || (event.imaginaryTarget || {})[attr];
}
